<div class="grid" id="top" #top>
  <div class="grid-5-8 row-1">
    <img src="../../assets/images/logo.svg" />
  </div>
  <h3 class="grid-2-11 row-2">
    Ihr Elektrotechnik Unternehmen bei Installation und Service, Montage und
    technischer Beratung.
  </h3>
</div>

<div class="bg grid" id="motto">
  <div class="grid-4-9">
    <h1>Unser Motto: „zufriedene Kunden“</h1>
    <p>
      Das von Peter Leutgeb 2006 gegründete Linzer Unternehmen bietet
      Dienstleistungen rund um das Thema Elektrotechnik an. Ein junges,
      dynamisches Team setzt auf individuelle Beratung und optimale Umsetzung
      der Kundenwünsche.
    </p>
    <p>
      Wir überzeugen durch Kompetenz, Wissen und termingerechter
      Leistungserbringung.
    </p>
  </div>
</div>

<div id="angebot" #angebot>
  <div class="grid">
    <div class="angebot-entry grid-3-4 row-1">
      <div>
        <div>
          <p>Smart-Home Steuerung</p>
          <p>Bussysteme</p>
        </div>
      </div>
    </div>

    <div class="angebot-entry grid-5-6 row-1">
      <div>
        <div>
          <p>
            <a href="https://www.loxone.com/dede/" target="_blank"
              >Silver Partner für Haus und Gebäude&shy;automation</a
            >
          </p>
        </div>
      </div>
    </div>

    <div class="angebot-entry grid-7-8 row-1">
      <div>
        <div routerLink="https://www.loxone.com/dede/">
          <p>
            <a href="https://www.loxone.com/dede/" target="_blank"
              >viele Loxone Komponenten sind bei uns lagernd</a
            >
          </p>
        </div>
      </div>
    </div>
    <div class="angebot-entry grid-9-10 row-1">
      <div>
        <div>
          <p>Photovoltaik Anlagen</p>
        </div>
      </div>
    </div>

    <div class="angebot-entry grid-3-4 row-2">
      <div>
        <p>Einfamilien- und Mehrparteien&shy;häuser</p>
      </div>
    </div>

    <div class="angebot-entry grid-5-6 row-2">
      <div>
        <div>
          <p>Optimierung und Instandhaltung von Gewerbe&shy;anlagen</p>
        </div>
      </div>
    </div>

    <div class="angebot-entry grid-7-8 row-2">
      <div>
        <div>
          <p>Überprüfungs&shy;befunde Anlagebuch inkl. E-Befund nach Ö-Norm</p>
        </div>
      </div>
    </div>

    <div class="angebot-entry grid-9-10 row-2">
      <div>
        <div>
          <p>SAT Anlagen</p>
        </div>
      </div>
    </div>
  </div>
  <div class="line">
    <svg
      width="1440"
      height="491"
      viewBox="0 0 1440 491"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M-50.5 8L1149.5 47.5C1473.5 56.5 1413.5 232 1268 244.5C970.853 270.028 443.229 252.013 201.5 288.5C122 300.5 107.383 414.786 230.5 424.5C503 446 1038.5 494.5 1483.5 480.5L1578.5 468.5"
        stroke="#D81D28"
        stroke-width="15"
      />
    </svg>
  </div>
</div>

<div id="jobs" class="grid" #jobs>
  <div>
    <h1>Jobs und Karriere</h1>
    <h2>Aktuell wird gesucht:</h2>
    <p class="text-center">
      * Lehrling für Elektrotechnik<br />
      * Elektrotechniker/in
    </p>
  </div>
  <div class="grid-3-6 row-2">
    <div class="card">
      <h4>Lehrling Elektrotechnik</h4>
      <div>
        <p>
          Als Elektrotechniker / Elektrotechnikerin bist du in unterschiedlichen
          Bereichen, auf Baustellen und in privaten Haushalten tätig. Du planst,
          montierst, installierst, wartest und reparierst elektrische Anlagen
          wie z. B. SAT-Anlagen, Licht- und Beleuchtungsanlagen, Bauprovisorien,
          Kommunikationsanlagen. Du suchst und behebst Fehler und Störungen an
          elektrotechnischen Systemen und achtest bei all deinen Arbeiten genau
          auf die Einhaltung von Sicherheitsvorschriften, Schutzmaßnahmen und
          Standards.
        </p>

        <h6>Was erwarten wir von dir?</h6>
        <p class="ul-star">
          <span>* </span>
          <span>mit guten Noten abgeschlossene Pflichtschule</span><br />
          <span>* </span> <span>handwerkliches Geschick</span><br />
          <span>* </span> <span>technisches Interesse</span><br />
          <span>* </span> <span>Genauigkeit</span><br />
          <span>* </span><span>offenes Wesen, Bereitschaft "mitanzupacken"</span
          ><br />
        </p>

        <p>Lehrzeit: 3,5 Jahre</p>
        <p>
          Modullehrberuf: Elektrotechnik<br />
          Grundmodul: Elektro- und Gebäudetechnik<br />
          Spezialmodul: nach Vereinbarung
        </p>
      </div>
    </div>
  </div>
  <div class="grid-7-10 row-2">
    <div class="card">
      <h4>Elektrotechniker/in</h4>
      <div>
        <h6>Ihre Aufgabengebiete:</h6>
        <p class="ul-star">
          <span>* </span>
          <span>Elektroinstallationen im Privat- und Objektbereich </span><br />
          <span>* </span> <span> Kommunikationsanlagen</span><br />
          <span>* </span> <span>Aufbau und Verdrahtung von Schaltschränken</span
          ><br />
          <span>* </span> <span>Störungsbehebungen</span>
        </p>

        <h6>Ihr Profil:</h6>
        <p class="ul-star">
          <span>* </span>
          <span>abgeschlossene Ausbildung zum Elektrotechniker (Lehre)</span
          ><br />
          <span>* </span> <span>mind. 3 Jahre Berufserfahrung</span><br />
          <span>* </span>
          <span
            >selbstständiges und eigenverantwortliches Abwickeln von
            Baustellen</span
          ><br />
          <span>* </span>
          <span>kundenfreundliches Auftreten, flexibilität, teamfähigkeit</span
          ><br />
          <span>* </span> <span>Führerschein B</span>
        </p>

        <p>
          Bezahlung laut KV, Überzahlung je nach Qualifikation und
          Berufserfahrung
        </p>
      </div>
    </div>
    <p class="contact-entry">
      Ihre aussagekräftige Bewerbung mit Lebenslauf, Zeugnis und Foto senden Sie
      bitte an Elektrotechnik Leutgeb, Markt 36, 4280 Königswiesen;
      <a href="mailto:office@elektrotechnik-leutgeb.at"
        >office@elektrotechnik-leutgeb.at</a
      >
    </p>
  </div>
</div>
<div id="kontakt" class="grid" #kontakt>
  <div>
    <h1>Kontakt</h1>
  </div>
  <div class="grid-2-6 row-2">
    <h2>Leutgeb Peter</h2>
    <p>
      <span>Dauphinestraße 79a, <span>4030 Linz</span></span
      ><i class="fa fa-map-marker"></i>
    </p>
    <p>
      <span><a href="tel:+436645243714">+43 664 / 52 43 714</a></span
      ><i class="fa fa-phone"></i>
    </p>
  </div>
  <div class="grid-7-11 row-2">
    <h2>Christian Hausleitner</h2>
    <p>
      <i class="fa fa-map-marker"></i
      ><span>Markt 36, <span>4280 Königswiesen</span></span>
    </p>
    <p>
      <i class="fa fa-phone"></i
      ><span><a href="tel:+436644262729">+43 664 / 42 62 729</a></span>
    </p>
    <p>
      <i class="fa fa-clock"></i
      ><span>Di: 8.00 - 17.00 Uhr, Mi+Fr: 8.00 - 12.00 Uhr</span>
    </p>
  </div>
  <h3 class="row-3">
    <a href="mailto:office@elektrotechnik-leutgeb.at"
      >office@elektrotechnik-leutgeb.at</a
    >
  </h3>
</div>
<div id="standort" class="grid" #standort>
  <div class="grid-2-6 card" *ngIf="showMaps">
    <h4>Linz</h4>
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d169422.24029228737!2d14.40478172030711!3d48.43306919189863!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47739621354e8dc5%3A0xc3f56dba174edf71!2sLeutgeb%20Peter%20Elektrotechnik!5e0!3m2!1sde!2sat!4v1590943353878!5m2!1sde!2sat"
      width="100%"
      height="300px"
      frameborder="0"
      style="border: 0"
      allowfullscreen=""
      aria-hidden="false"
      tabindex="0"
    ></iframe>
  </div>
  <div class="grid-7-11 card" *ngIf="showMaps">
    <h4>Königswiesen</h4>
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2648.603914145848!2d14.837679315906481!3d48.40654914036756!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4772fffe66b00001%3A0xeecfe953107ed016!2sElektrotechnik%20Leutgeb!5e0!3m2!1sde!2sat!4v1590943591839!5m2!1sde!2sat"
      width="100%"
      height="300px"
      frameborder="0"
      style="border: 0"
      allowfullscreen=""
      aria-hidden="false"
      tabindex="0"
    ></iframe>
  </div>
  <div class="grid-2-11" *ngIf="!showMaps">
    <button class="center" (click)="showMaps = true">Karte anzeigen</button>
    <p class="center">
      <small
        >Durch das anzeigen der Karte akzeptieren Sie die Nutzung von
        Analyse-Cookies durch Google.</small
      >
    </p>
  </div>
</div>
<footer class="grid">
  <div class="grid-5-7 row-1">
    <span id="facebook"
      ><a
        href="https://www.facebook.com/Elektrotechnik-Leutgeb-Peter-GmbH-1751282935200684/"
        >f</a
      ></span
    >
  </div>
  <div class="grid-2-11 row-2">
    <a routerLink="/impressum">Impressum</a>
  </div>
</footer>
